import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, LinkData } from '../../../types'
import { CmsConverterService, defaultLinkData } from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class PanelRowRelatedContentLinkConverter extends CmsConverterService<PanelRowRelatedContentLinkData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      link: formData.st_link ?? defaultLinkData
    }
  }
}

export const PANEL_ROW_RELATED_CONTENT_LINK_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, PanelRowRelatedContentLinkData>>('PanelRowRelatedContentLinkConverter')

export interface PanelRowRelatedContentLinkData extends ConvertedComponentData {
  link: LinkData;
}
